import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialShrink1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 0H32v1.52h-1.53Zm-1.52 1.52h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53ZM25.9 4.57h1.52v1.52H25.9Zm-1.52 1.52h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52H19.8Z\"/><path fill=\"currentColor\" d=\"M18.28 6.09h-1.52v9.15h9.14v-1.53h-6.1v-1.52h-1.52zM13.71 25.9h1.52v-9.14H6.09v1.53h6.1v1.52h1.52z\"/><path fill=\"currentColor\" d=\"M10.66 19.81h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53H9.14Zm-1.53 1.53h1.53v1.52H7.61Zm-1.52 1.52h1.52v1.52H6.09ZM4.57 25.9h1.52v1.53H4.57Zm-1.53 1.53h1.53v1.52H3.04Zm-1.52 1.52h1.52v1.53H1.52ZM0 30.48h1.52V32H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialShrink1
